import request from '../../request';

export function bookedIntervalAPI(query: any) {
  return request(
    {
      url: `/api/v1/booking/booked-interval/?product=${query.room}&start=${query.start}&end=${query.end}`,
      method: 'GET',
    },
    false,
  );
}

export function eventListAPI(query: any, statuses?: any) {
  const currentStatuses = statuses ? statuses : ['SENT', 'CONFIRMED']
  let allowedStatuses = ''
  currentStatuses?.map((status: string) => allowedStatuses += `&status=${status}`)
  return request(
    {
      url: `/api/v1/booking/interval-list/?product=${query.room}&start=${query.start}&end=${query.end}${allowedStatuses}`,
      method: 'GET',
    },
    true,
  );
}

export function reservationsListAPI(data: any) {
  let allowedStatuses = ''
  data.statuses?.map((status: string) => allowedStatuses += `&status=${status}`)
  return request(
    {
      url: `/api/v1/booking/booking/?page=${data.page}&page_size=${data.pageSize ? data.pageSize : 15}${allowedStatuses}&search=${data.search ? data.search : ''}`,
      method: 'GET',
    },
    true,
  );
}

export function sendBookingAPI(data: any) {
  return request(
    {
      url: `/api/v1/booking/booking/`,
      method: 'POST',
      data: data,
    },
    true,
  );
}

export function deleteReservationAPI(data: any) {
  return request(
    {
      url: `/api/v1/booking/booking/${data.id}/cancel/`,
      method: 'PUT',
      data: { message: data.message }
    },
    true
  );
}

export function retrieveReservationAPI(id: string) {
  return request(
    {
      url: `/api/v1/booking/booking/${id}/`,
      method: 'GET',
    },
    true
  );
}

export function confirmReservationAPI(data: any) {
  return request(
    {
      url: `/api/v1/booking/booking/${data.id}/confirm/`,
      method: 'PUT',
      data: { message: data.message }
    },
    true
  );
}

export function addAdminNoteAPI(data: any) {
  return request(
    {
      url: `/api/v1/booking/booking/${data.id}/`,
      method: 'PATCH',
      data: { admin_notes: data.message }
    },
    true
  );
}

export function checkInOutEventReservationAPI(data: any) {
  return request(
    {
      url: `/api/v1/booking/booking/${data.bookingId}/do_action/`,
      method: 'PUT',
      data: data.dataToSend,
  },
    true
  );
}

export function updateReservationAPI(id: string, data: any) {
  return request(
    {
      url: `/api/v1/booking/booking/${id}/modify/`,
      method: 'PUT',
      data: data,
    },
    true
  );
}
export function sendEmailAPI(data: any) {
  return request(
    {
      url: `/api/v1/booking/send-email/`,
      method: 'POST',
      data: data,
    },
    true,
  );
}

export function uploadCsvAPI(formData: any) {
  return request(
    {
      url: `/api/v1/booking/attendees-list/`,
      method: 'POST',
      data: formData,
      transformRequest: (data: any, headers: any) => {
        return formData;
      },
    },
    true,
    true
  );
}

export function allEventListAPI(data: any) {
  return request(
    {
      url: `/api/v1/booking/interval-list/?page=${data.page}&page_size=${data.pageSize ? data.pageSize : 15}&status=SENT&status=CONFIRMED`,
      method: 'GET',
    },
    true,
  );
}

export function attendeesListAPI(data: any) {
  return request(
    {
      url: `/api/v1/booking/attendees-list/?interval=${data.id}`,
      method: 'GET',
    },
    true,
  );
}

export function attendeesCheckInAPI(data: any) {
  return request(
    {
      url: `/api/v1/booking/attendees-list/${data.id}/check-in/`,
      method: 'PUT',
      data: data.check_in
    },
    true,
  );
}

export function retrieveEventAPI(id: string) {
  return request(
    {
      url: `/api/v1/booking/interval-list/${id}/`,
      method: 'GET',
    },
    true
  );
}

export function updateIntervalPaymentStatusAPI(data: any) {
  const dataToSend = {
    interval_id: data.interval_id
  }
  return request(
    {
      url: `/api/v1/booking/booking/${data.booking_id}/update-payment-status/`,
      method: 'PUT',
      data: dataToSend
    },
    true
  );
}

export function getTBLinkAPI(id: any) {
  return request(
    {
      url: `/api/v1/thingsboard/to-dashboard/?interval_id=${id}`,
      method: 'GET',
    },
    true
  );
}

